import createStore from "zustand";
import persist from "../utils/persist";

const useUserStore = createStore(
  persist(
    {
      key: "principally_user",
      denylist: ["isLoading", "errorMessage"],
    },
    (set) => ({
      isLoading: false,
      errorMessage: "",
      user: null,
      setUser: (newUser) => {
        set((state) => ({
          user: newUser,
        }));
      },

      updateNotes: (notes) => {
        set((state) => ({
          user: { ...state.user, notes: notes },
        }));
      },

      updateScript: (script) => {
        set((state) => ({
          user: { ...state.user, document: script },
        }));
      },

      clearUser: () => {
        set((state) => ({
          user: null,
        }));
      },
    })
  )
);

export default useUserStore;
